import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { RecallLogo } from './Header';
const footerLinks = [{
  label: 'How it works',
  hash: '#how-it-works'
}, {
  label: 'Features',
  hash: '#features'
}, {
  label: 'Privacy',
  hash: '#privacy'
}, {
  label: 'Use cases',
  hash: '#use-cases'
}, {
  label: 'FAQ',
  hash: '#faq'
}];
export function Footer() {
  const {
    pathname
  } = useLocation();
  const onHome = pathname === '/';
  return <footer className="border-t border-slate-200 bg-slate-50" data-id="element-153">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12" data-id="element-154">
        <div className="flex flex-col items-center gap-8 sm:flex-row sm:justify-between" data-id="element-155">
          <Link to="/" className="flex items-center gap-2.5" aria-label="Recall home" data-id="element-156">
            <RecallLogo size="sm" data-id="element-157" />
            <span className="leading-tight" data-id="element-158">
              <span className="font-display block text-sm font-bold text-ink tracking-tight" data-id="element-159">
                Recall
              </span>
              <span className="block text-[11px] text-slate-500 -mt-0.5" data-id="element-160">
                Total recall for every borrower.
              </span>
            </span>
          </Link>

          <nav aria-label="Footer navigation" data-id="element-161">
            <ul className="flex flex-wrap items-center justify-center gap-x-7 gap-y-2" data-id="element-162">
              {footerLinks.map(link => <li key={link.hash} data-id="element-163">
                  <a href={onHome ? link.hash : `/${link.hash}`} className="text-sm text-slate-600 hover:text-slate-900 transition-colors" data-id="element-164">
                    {link.label}
                  </a>
                </li>)}
              <li data-id="element-165">
                <Link to="/pricing" className="text-sm text-slate-600 hover:text-slate-900 transition-colors" data-id="element-166">
                  Pricing
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-center gap-4 border-t border-slate-200 pt-8 sm:flex-row sm:justify-between" data-id="element-167">
          <p className="font-mono-brand text-xs text-slate-500" data-id="element-168">
            © 2026 Recall. All rights reserved.
          </p>
          <ul className="flex items-center gap-6" data-id="element-169">
            <li data-id="element-170">
              <a href="#" className="text-xs text-slate-500 hover:text-slate-700 transition-colors" data-id="element-171">
                Privacy Policy
              </a>
            </li>
            <li data-id="element-172">
              <a href="#" className="text-xs text-slate-500 hover:text-slate-700 transition-colors" data-id="element-173">
                Terms of Service
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>;
}